module.exports = __webpack_public_path__ + "static/media/neko-young-narrow.dfc08b32.png";